export const range = (start: number, stop: number, step: number, decimalDigits: number = 0): number[] =>
    Array.from({ length: (stop - start) / step + 1 }, (_, i) => Number((start + i * step).toFixed(decimalDigits)));
